/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Toast_DeletedInputs */

const he_notifications_toast_deleted = /** @type {(inputs: Notifications_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראה בוטלה בהצלחה`)
};

const en_notifications_toast_deleted = /** @type {(inputs: Notifications_Toast_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification removed`)
};

/**
* | output |
* | --- |
* | "Notification removed" |
*
* @param {Notifications_Toast_DeletedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_toast_deleted = /** @type {((inputs?: Notifications_Toast_DeletedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Toast_DeletedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_toast_deleted(inputs)
	return en_notifications_toast_deleted(inputs)
});